import styled from 'styled-components';
export var StyledChipSpinner = /*#__PURE__*/styled.span.withConfig({
  displayName: "StyledChipSpinner",
  componentId: "c11n-8-111-1__sc-1ab09lt-0"
})([""]);